// extracted by mini-css-extract-plugin
export default {"warningWrapper":"WarningMessage_warningWrapper__cKg1Q","warningIcon":"WarningMessage_warningIcon__eMx9-"};